import { createSliderWidget } from "../../widgets/slider.js";
import { ACADEMIC_SLIDER_QUERY } from "../../strategies/fetch/academic.js";
const academicSlider = (props) => createSliderWidget({
  ...props,
  query: ACADEMIC_SLIDER_QUERY,
  url: "https://provost.umd.edu/graphql"
});
export {
  academicSlider
};
//# sourceMappingURL=slider.js.map
